import { PartFinderReport } from '@/api/generatedApi';

export const resolveContextTargetReportIds = (
  report: PartFinderReport | undefined,
  selectedReportIds: string[]
): string[] => {
  if (!report) return [];
  if (selectedReportIds.includes(report.id) && selectedReportIds.length > 1) return selectedReportIds;
  return [report.id];
};
